.container {
  isolation: isolate;
  height: 100%;
}

.tree {
  position: relative;
  z-index: 1;
}

.tree.dragging .node_children_container {
  pointer-events: 'auto';
}

.tree:global(.dragging) {
  user-select: none;
}

.node {
  display: flex;
  position: relative;
}

.node + .node {
  border-top: 2px solid #ffffff88;
}

.targeted_node_start > .node_head > .node_content:before {
  content: '';
  display: block;
  height: 2px;
  position: absolute;
  top: calc(-0.125rem - 3px);
  left: 0;
  width: 10rem;
  background-color: orange;
}

.targeted_node_end > .node_head > .node_content:after {
  content: '';
  display: block;
  height: 2px;
  position: absolute;
  bottom: calc(-0.125rem - 3px);
  left: 0;
  width: 10rem;
  background-color: blue;
}

.node_content {
  padding: 1rem 0;
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.node_head {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
}

.node_position_indicator {
  flex: 0 1 auto;
  width: 2rem;
}

.node_position_indicator_0 {
  background-color: #bbff9e;
}

.node_position_indicator_1 {
  background-color: #9eecff;
}

.node_position_indicator_2 {
  background-color: #bd9eff;
}

.node_position_indicator_3 {
  background-color: #ff9e9e;
}

.node_position_indicator_4 {
  background-color: #ffdb9e;
}

.node [data-expandable='true'] {
  cursor: pointer;
}

.node_content {
  flex: 1;
  border-radius: 0 8px 8px 0;
  padding: 0.5rem;
}

.target_node[data-colordex='0'] .node_head {
  background-color: #bbff9e;
}

.target_node[data-colordex='1'] .node_head {
  background-color: #9eecff;
}

.target_node[data-colordex='2'] .node_head {
  background-color: #bd9eff;
}

.target_node[data-colordex='3'] .node_head {
  background-color: #ff9e9e;
}

.target_node[data-colordex='-1'] .node_head,
.target_node[data-colordex='4'] .node_head {
  background-color: #ffdb9e;
}

.node_drag_handle {
  cursor: grab;
}
/* 
.node[data-index='0'] .node_position_indicator {
  margin-top: -0.25rem;
}

.node:last-child .node_position_indicator {
  margin-bottom: -0.25rem;
}
.node_final_child .node_position_indicator {
  margin-bottom: -0.25rem;
} */
